<template>
  <div class="modal-body-perguntas-frequentes">
    <div
      class="perguntas-frequentes-modal-container base animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="perguntas-frequentes-modal-close">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="perguntas-frequentes-modal-container1">
        <v-row>
          <v-col cols="12">
            <label class="input-labels">Ordem</label>
            <v-text-field
              hide-details
              v-model="$marketplace.question.ordem"
              solo
              class="perguntas-frequentes-textinput"
              placeholder="Insira a ordem da pergunta"
              type="number"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <label class="input-labels">Pergunta</label>
            <v-text-field
              hide-details
              v-model="$marketplace.question.pergunta_pt_BR"
              solo
              class="perguntas-frequentes-textinput"
              placeholder="Insira a pergunta"
              type="text"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <label class="input-labels">Resposta</label>
            <vue-editor
              v-model="$marketplace.question.resposta_pt_BR"
              placeholder="Insira a resposta"
              class="lojas-gerenciar-tema-container-text-imagem-input"
              :editor-toolbar="customToolbar"
              id="frequently-questions-editor"
            >
            </vue-editor>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="5">
            <div class="perguntas-frequentes-container6 secondary">
              <v-checkbox v-model="$marketplace.question.tem_traducao">
                <template v-slot:label>
                  <div>Adicionar traduções</div>
                </template>
              </v-checkbox>
            </div>
          </v-col>
        </v-row>
        <div v-show="$marketplace.question.tem_traducao">
          <v-row>
            <v-col cols="12">
              <label class="input-labels">Pergunta inglês</label>
              <v-text-field
                hide-details
                v-model="$marketplace.question.pergunta_en_US"
                solo
                class="perguntas-frequentes-textinput"
                placeholder="Insira a descrição da pergunta"
                type="text"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="input-labels">Resposta inglês</label>
              <vue-editor
                id="frequently-questions-editor2"
                v-model="$marketplace.question.resposta_en_US"
                :editor-toolbar="customToolbar"
                placeholder="Insira a resposta"
                class="lojas-gerenciar-tema-container-text-imagem-input"
              ></vue-editor>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="input-labels">Pergunta espanhol</label>
              <v-text-field
                hide-details
                v-model="$marketplace.question.pergunta_es_ES"
                solo
                class="perguntas-frequentes-textinput"
                placeholder="Insira a descrição da pergunta"
                type="text"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="input-labels">Resposta espanhol</label>
              <vue-editor
                id="frequently-questions-editor3"
                v-model="$marketplace.question.resposta_es_ES"
                :editor-toolbar="customToolbar"
                placeholder="Insira a resposta"
                class="lojas-gerenciar-tema-container-text-imagem-input"
              ></vue-editor>
            </v-col>
          </v-row>
        </div>
        <v-row class="justify-end pa-3">
          <RegistrationActions :fixed="true" :actions="actions" />
        </v-row>
      </div>
      <ModalTraducoes />
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "FrequentlyQuestionsDialog",
  components: {
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    ModalTraducoes: () => import("@/components/global/modal-traducoes.vue"),
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
    VueEditor,
  },
  props: ["questionEdit", "qstIdx"],
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.saveQuestion(),
        },
        {
          name: "Cancelar",
          action: () => this.closeModal(),
        },
      ],
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["link"],
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        // ["blockquote"],
        ["clean"], // remove formatting button
      ],
    };
  },
  methods: {
    cleanQuestionForm() {
      this.$marketplace.question.ordem = "";
      this.$marketplace.question.pergunta_pt_BR = "";
      this.$marketplace.question.pergunta_en_US = "";
      this.$marketplace.question.pergunta_es_ES = "";
      this.$marketplace.question.resposta_pt_BR = "";
      this.$marketplace.question.resposta_en_US = "";
      this.$marketplace.question.resposta_es_ES = "";
      this.$marketplace.question.tem_traducao = false;
    },
    saveQuestion() {
      if (this.$marketplace.cadastro.configsPlusAddEdit == "new") {
        this.$marketplace.cadastro.perguntas_frequentes.push({
          ordem: this.$marketplace.question.ordem,
          pergunta: `<pt_BR>${this.$marketplace.question.pergunta_pt_BR}</pt_BR><en_US>${this.$marketplace.question.pergunta_en_US}</en_US><es_ES>${this.$marketplace.question.pergunta_es_ES}</es_ES>`,
          resposta: `<pt_BR>${this.$marketplace.question.resposta_pt_BR}</pt_BR><en_US>${this.$marketplace.question.resposta_en_US}</en_US><es_ES>${this.$marketplace.question.resposta_es_ES}</es_ES>`,
          tem_traducao: this.$marketplace.question.tem_traducao,
        });

        document.getElementsByClassName(
          "modal-body-perguntas-frequentes"
        )[0].style.display = "none";
      } else {
        this.$marketplace.cadastro.perguntas_frequentes[
          this.$marketplace.questionIdx
        ].ordem = this.$marketplace.question.ordem;
        this.$marketplace.cadastro.perguntas_frequentes[
          this.$marketplace.questionIdx
        ].pergunta = `<pt_BR>${this.$marketplace.question.pergunta_pt_BR}</pt_BR><en_US>${this.$marketplace.question.pergunta_en_US}</en_US><es_ES>${this.$marketplace.question.pergunta_es_ES}</es_ES>`;
        this.$marketplace.cadastro.perguntas_frequentes[
          this.$marketplace.questionIdx
        ].resposta = `<pt_BR>${this.$marketplace.question.resposta_pt_BR}</pt_BR><en_US>${this.$marketplace.question.resposta_en_US}</en_US><es_ES>${this.$marketplace.question.resposta_es_ES}</es_ES>`;
        this.$marketplace.cadastro.perguntas_frequentes[
          this.$marketplace.questionIdx
        ].tem_traducao = this.$marketplace.question.tem_traducao;

        document.getElementsByClassName(
          "modal-body-perguntas-frequentes"
        )[0].style.display = "none";
      }
    },
    closeModal() {
      document.getElementsByClassName(
        "modal-body-perguntas-frequentes"
      )[0].style.display = "none";
      this.cleanQuestionForm();
    },
  },
  watch: {
    "$marketplace.question.tem_traducao"(e) {
      if (!e) {
        this.$marketplace.question.pergunta_en_US = "";
        this.$marketplace.question.resposta_en_US = "";
        this.$marketplace.question.pergunta_es_ES = "";
        this.$marketplace.question.resposta_es_ES = "";
      }
    },
  },
};
</script>

<style scoped>
.modal-body-perguntas-frequentes {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 888;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.perguntas-frequentes-modal-container {
  max-width: 850px;
  max-height: 700px;
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.0825rem;
  border-radius: 1.365rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.perguntas-frequentes-modal-close {
  width: 100%;
  height: 5%;
  display: flex;
  justify-content: flex-end;
  padding: 0.325rem;
}

.perguntas-frequentes-modal-container1 {
  width: 100%;
  height: 85%;
  overflow-y: auto;
  padding: 1rem;
}

.perguntas-frequentes-textinput {
  width: 100%;
  height: 51;
  border-radius: 0.625rem;
  margin-top: 0.375rem;
}

.lojas-gerenciar-tema-container-text-imagem-input {
  height: auto;
  width: 100%;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
  background: #fff;
  overflow: auto;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.perguntas-frequentes-container6 {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0.125rem 1.5625rem;
  background-color: #c9c9c9;
  border-radius: 0.9375rem;
}

@media (max-width: 1366px) {
  .perguntas-frequentes-modal-container {
    width: 720px;
    max-height: 450px;
  }
}
</style>
